import React, { useEffect, useState } from 'react'
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faCalendar, faListCheck, faCashRegister,  
    faPiggyBank, faCarrot, faBookOpen, faSeedling, 
    faUtensils, faCloudMoon, faSuitcase, faCar, faTrash, faUserCheck, 
    faSyringe, faHandHoldingHeart, faHeart, faClipboardList, 
    faUsers, faHeart as faHeartSolid,
    faCameraRetro, faFaceSmile, faFaceGrinHearts, faDog, faCat, faHorse,
    faCow, faDove, faCalendarCheck, faFeatherAlt,faPenFancy, faCalendarDays, faCheckCircle, 
    faMobileScreen, faHandsPraying, faHeartCircleCheck, faBrain, faGamepad, faTree, 
    faStar, faBreadSlice, faEnvelopeOpenText, faMoneyBillWave, faReceipt, faFolderOpen,
    faExclamationTriangle, faDumbbell, faHospitalUser, faPrescriptionBottleMedical, faLeaf, faRulerCombined, faHeartPulse,
    faShoppingBasket, faCalendarPlus, faBullseye, faHourglassEnd, faTasks, faGift
} from '@fortawesome/free-solid-svg-icons';
import './LifeChroniclesHome.css';

// const categories = [
//     { to: "/attendance-list", icon: faUserCheck, label: "Attendance", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/calendar-list", icon: faCalendar, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/missed-opportunities-list", icon: faHourglassEnd, label: "Missed-opportunities", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly-essentials-plan", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/routine-others-list", icon: faCalendarPlus, label: "Routine-Others", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/study-list", icon: faBookOpen, label: "Study", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
//     { to: "/digitaltime-list", icon: faMobileScreen, label: "DigitalTime", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/gardening-list", icon: faSeedling, label: "Gardening", bgColor: "bg-gray-600", textColor: "text-white" },  
//     { to: "/gratitude-list", icon: faHandsPraying, label: "Gratitude", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/invitations-list", icon: faEnvelopeOpenText, label: "Invitations", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/play-sports-list", icon: faGamepad, label: "Play-Sports", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-gray-600", textColor: "text-white" }, 
//     { to: "/regrets-list", icon: faTrash, label: "Regret", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/sympathy-list", icon: faHeartCircleCheck, label: "Sympathy", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-gray-600", textColor: "text-white" },
//     { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-green-600", textColor: "text-white" },
//     { to: "/assets-list", icon: faPiggyBank, label: "Assets", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/income-list", icon: faEnvelopeOpenText, label: "Income", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/investments-list", icon: faMoneyBillWave, label: "Investments", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/loans-list", icon: faMoneyBillWave, label: "Loans", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/petty-account-list", icon: faCashRegister, label: "Petty-Account", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/subscription-list", icon: faReceipt, label: "Subscriptions", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-cyan-600", textColor: "text-white" },
//     { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
//     { to: "/routine-diet-list", icon: faCarrot, label: "DietRoutine", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/exercise-list", icon: faDumbbell, label: "Exercise", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/gym-list", icon: faDumbbell, label: "Gym", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/yoga-list", icon: faHeartPulse, label: "Yoga", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
//     { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-orange-600", textColor: "text-white" },
//     { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-purple-600", textColor: "text-white" },
//     { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-700", textColor: "text-white" },
//     { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-pink-600", textColor: "text-white" },
//     { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-yellow-700", textColor: "text-white" },
//     { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-teal-700", textColor: "text-white" },
//     { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-red-700", textColor: "text-white" },
//     { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly Essentials Plan", bgColor: "bg-yellow-700", textColor: "text-white" },
//     { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-yellow-400", textColor: "text-red" },
//     { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-teal-500", textColor: "text-white" },
//     { to: "/play-sports-list", icon: faGamepad, label: "Play / Sports", bgColor: "bg-purple-800", textColor: "text-white" },
//     { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-purple-800", textColor: "text-white" },
//     { to: "/tasks-list", icon: faTasks, label: "Tasks", bgColor: "bg-gray-700", textColor: "text-white" },
//     { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-blue-800", textColor: "text-white" },
//     { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-purple-500", textColor: "text-white" },
//     { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-yellow-800", textColor: "text-white" },
//     { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
//     { to: "/visits-list", icon: faCar, label: "Visits", bgColor: "bg-red-900", textColor: "text-white" },
//     { to: "/routine-diet-list", icon: faCarrot, label: "Diet Routine", bgColor: "bg-orange-500", textColor: "text-white" },
//     { to: "/exercise-list", icon: faDumbbell, label: "Gym/Yoga/Exercise", bgColor: "bg-red-600", textColor: "text-white" },
//     { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-800", textColor: "text-white" },
//     { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-800", textColor: "text-white" },
//     { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-indigo-800", textColor: "text-white" },
//     { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-green-800", textColor: "text-white" },
//     { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
//     { to: "/memories-list", icon: faCameraRetro, label: "Motherhood Memories", bgColor: "bg-purple-900", textColor: "text-white" },
// ];

const categories = [
  { to: "/attendance-list", icon: faUserCheck, label: "Attendance", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/calendar-list", icon: faCalendar, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/missed-opportunities-list", icon: faHourglassEnd, label: "Missed-opportunities", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly-essentials-plan", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/routine-others-list", icon: faCalendarPlus, label: "Routine-Others", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/study-list", icon: faBookOpen, label: "Study", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-indigo-600", textColor: "text-white" },
  { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
  { to: "/digitaltime-list", icon: faMobileScreen, label: "DigitalTime", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/gardening-list", icon: faSeedling, label: "Gardening", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/gratitude-list", icon: faHandsPraying, label: "Gratitude", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/invitations-list", icon: faEnvelopeOpenText, label: "Invitations", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/memories-list", icon: faCameraRetro, label: "Memories", bgColor: "bg-gray-600", textColor: "text-white" },  
  { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/play-sports-list", icon: faGamepad, label: "Play-Sports", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/regrets-list", icon: faTrash, label: "Regret", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/sympathy-list", icon: faHeartCircleCheck, label: "Sympathy", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-gray-600", textColor: "text-white" },
  { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-green-600", textColor: "text-white" },
  { to: "/assets-list", icon: faPiggyBank, label: "Assets", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/income-list", icon: faEnvelopeOpenText, label: "Income", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/investments-list", icon: faMoneyBillWave, label: "Investments", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/loans-list", icon: faMoneyBillWave, label: "Loans", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/petty-account-list", icon: faCashRegister, label: "Petty-Account", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/subscription-list", icon: faReceipt, label: "Subscriptions", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-cyan-600", textColor: "text-white" },
  { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
  { to: "/routine-diet-list", icon: faCarrot, label: "DietRoutine", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/exercise-list", icon: faDumbbell, label: "Exercise", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/gym-list", icon: faDumbbell, label: "Gym", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/yoga-list", icon: faHeartPulse, label: "Yoga", bgColor: "bg-teal-600", textColor: "text-white" },
  { to: "/eyewear-record-list", icon: faHeartPulse, label: "Eyewear-Record", bgColor: "bg-teal-600", textColor: "text-white" },

];

const LifeChroniclesHome = () => {
    const navigate = useNavigate();
    const authState = useSelector((state) => state.authReducer || {});
      const isLoggedIn = authState?.isLoggedIn || false;
      const userName = authState?.user?.name || "User";
    
      const dispatch = useDispatch();
    
      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
      const [activeTab, setActiveTab] = useState("Digital Income");
    
      const handleLogout = () => {
        dispatch(logout());
        navigate("/sheearns");
      };

    const [myHealthCardClicked, setMyHealthCardClicked] = useState(false);
    const [chronicleClicked, setChronicleClicked] = useState(false);
    const [petDashboardClicked, setPetDashboardClicked] = useState(false);

    const handleChronicleClicked = () => {
        setChronicleClicked(!chronicleClicked);
    }
    
    const handleMyHealthCardClicked = () => {
        setMyHealthCardClicked(true);
    }

    const handlePetDashboardClicked = () => {
        setPetDashboardClicked(true);
    }

    const handleMyDiariesClicked = () => {
        navigate("/mydiary-home");
    }

    const handleMyJournalsClicked = () => {
        navigate("/myjournal-home");
    }

    return (
        <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
            <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
            <div className="flex flex-col">
                <div className="text-lg lg:text-xl font-bold text-yellow-200">📅 Life & Work Chronicles</div>
                <div className="text-sm lg:text-m text-white">Data captured. Insights revealed. Transformation begins.</div>              
            </div>

            <div className="hidden md:flex items-center gap-3">
                {isLoggedIn ? (
                <>
                    <div className="text-xs text-left text-blue-300">{userName}</div>
                    <button
                    onClick={handleLogout}
                    className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                    title="Logout"
                    >
                    ⏻
                    </button>
                </>
                ) : (
                <>
                    <button
                    onClick={() => navigate("/login")}
                    className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                    >
                    Login
                    </button>
                </>
                )}
            </div>

            {/* Mobile hamburger */}
            <button
                onClick={() => setIsMobileMenuOpen((s) => !s)}
                className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
                aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? "×" : "☰"}
            </button>
            </header>

            {/* Mobile menu content */}
            {isMobileMenuOpen && (
            <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
                {isLoggedIn ? (
                <div className="flex flex-row items-center justify-center gap-3">
                    <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                        {userName}
                    </span>
                    <button
                    onClick={handleLogout}
                    className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                    title="Logout"
                    >
                    ⏻
                    </button>
                </div>
                ) : (
                <div className="flex flex-row items-center justify-center gap-6">
                    <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                    Login
                    </Link>
                </div>
                )}
            </div>
            )}

            <div className="flex items-center justify-center px-4 mt-4">
                <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 w-full place-items-center">
                    <button
                    onClick={handleChronicleClicked}
                    className="w-full px-2 py-3 rounded-md bg-blue-700 text-white 
                                shadow-md hover:shadow-xl transition flex items-center justify-center gap-2"
                    >
                    <FontAwesomeIcon icon={faCalendarCheck} className="text-red-600 text-lg" />
                    <span className="text-sm font-semibold text-yellow-300">My Chronicles</span>
                    </button>

                    <button
                    onClick={handleMyDiariesClicked}
                    className="w-full px-2 py-3 rounded-md bg-blue-700 text-white 
                                shadow-md hover:shadow-xl transition flex items-center justify-center gap-2"
                    >
                    <FontAwesomeIcon icon={faPenFancy} className="text-red-600 text-lg" />
                    <span className="text-sm font-semibold text-yellow-300">My Diaries</span>
                    </button>

                    <button
                    onClick={handleMyJournalsClicked}
                    className="w-full px-2 py-3 rounded-md bg-blue-700 text-white 
                                shadow-md hover:shadow-xl transition flex items-center justify-center gap-2"
                    >
                    <FontAwesomeIcon icon={faFeatherAlt} className="text-red-600 text-lg" />
                    <span className="text-sm font-semibold text-yellow-300">My Journals</span>
                    </button>

                    <button
                    onClick={handleMyHealthCardClicked}
                    className="w-full px-2 py-3 rounded-md bg-gray-600 text-white 
                                shadow-md hover:shadow-xl transition flex items-center justify-center gap-2"
                    >
                    <FontAwesomeIcon icon={faHeart} className="text-red-500 text-lg" />
                    <span className="text-sm font-semibold text-gray-200 text-center">
                        Health & Wellness Card
                    </span>
                    </button>

                    <button
                    onClick={handlePetDashboardClicked}
                    className="w-full px-2 py-3 rounded-md bg-gray-600 text-white 
                                shadow-md hover:shadow-xl transition flex flex-col sm:flex-row
                                items-center justify-center gap-2 text-center"
                    >
                    <div className="flex items-center justify-center gap-1">
                        <FontAwesomeIcon icon={faDog} className="text-white" />
                        <FontAwesomeIcon icon={faCat} className="text-black" />
                    </div>
                    <span className="text-sm font-semibold text-gray-200 sm:text-left">
                        Pet Wellness Card
                    </span>
                    </button>
                </div>
            </div>

            {chronicleClicked && (
                <div className="flex flex-col items-center p-4 bg-black border border-green-300 w-full">
                    <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 w-full">
                    {categories.map((category, index) => (
                        <Link
                        key={index}
                        to={category.to}
                        className={`flex flex-col items-center p-2 bg-black rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                        >
                        <FontAwesomeIcon icon={category.icon} size="x" className="mb-1" />
                        <span className="text-sm lg:text-m font-semibold flex items-center justify-center text-center">
                            {category.label}
                        </span>
                        </Link>
                    ))}
                    </div>
                </div>
            )}
            <footer className="bg-[#2a0f2f] border-t border-blue-800 text-blue-300 py-4 mt-auto">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                    © 2025 Think5Whys Global DeepTech Solutions.
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                    <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
        );
};

export default LifeChroniclesHome;
